import { GetAllNotificationResponse } from '@/types/apis/notifications/GetAllNotificationResponse'
import { UpdateNotificationRequest } from '@/types/apis/notifications/UpdateNotificationRequest'
import { UpdateNotificationResponse } from '@/types/apis/notifications/UpdateNotificationResponse'

import axios from './axios'

const API_ENDPOINT = '/notification'

export const getAllNotification = (): Promise<GetAllNotificationResponse> => {
  return axios.get(`${API_ENDPOINT}`, { params: { isApp: false } })
}

export const getNotificationCount = (): Promise<number> => {
  return axios.get(`${API_ENDPOINT}/count`, { params: { isApp: false } })
}

export const updateNotification = (id: UpdateNotificationRequest): Promise<UpdateNotificationResponse> => {
  return axios.put(`${API_ENDPOINT}/${id}`)
}
